import {
  FETCH_ASSAY_DETAIL,
  FETCH_ASSAYS,
  DISPLAY_MESSAGE,
  CLEAR_DISPLAY_MESSAGE,
  FETCHED_VALIDATED_ASSAYS,
  FETCHED_ASSAY_RESULTS,
  REMOVE_VALIDATED_RESULT,
  CLEAR_UUID_FOR_ASSAY,
  SUBMITTED_VALUES,
  CHANGE_MODAL_TYPE,
  LOADING_PAGE,
  ASSAY_ADDED_TO_LIST,
  SELECT_UUID_FOR_ASSAY,
  UPDATE_EDIT_REGION,
  REJECTED_COMMERCIAL_ID,
  CLEAR_COMMERCIAL_ID,
  SEARCH_RESULTS,
} from "../actions/assays";
import update from "immutability-helper";

const initialState = {
  cache: {
    data: {
      data: {
        complete: [],
        incomplete: [],
      },
      meta: {},
    },
  },
  detail: false,
  detailMeta: false,
  uuid: "",
  assayAdded: {},
  messages: [],
  fetchedAssayDetails: {},
  validatedAssayDetails: {},
  apiPayload: {},
  modalInfo: {
    modalType: "",
    uniqueAssayRowId: "",
  },
  searchResults: [],
  pageLoading: false,
  editRegionDonorRange: {},
  rejectedCommercializedId: [],
};

const assays = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ASSAYS:
      return {
        ...state,
        cache: {
          ...state.cache,
          data: {
            ...state.cache.data,
            data: {
              ...state.cache.data.data,
              complete: action.payload.data.data.complete,
              incomplete: action.payload.data.data.incomplete,
            },
            meta: action.payload.data.meta,
          },
        },
      };

    case FETCHED_VALIDATED_ASSAYS:
      return { ...state, validatedAssayDetails: action.payload };

    case FETCH_ASSAY_DETAIL:
      return { ...state, detail: action.payload, detailMeta: action.detailMeta };

    case DISPLAY_MESSAGE:
      return Object.assign({}, state, {
        messages: [
          {
            text: action.text,
            displayType: action.displayType,
            key: action.key,
          },
        ],
      });

    case FETCHED_ASSAY_RESULTS:
      return { ...state, fetchedAssayDetails: action.payload };

    case ASSAY_ADDED_TO_LIST:
      return { ...state, assayAdded: action.payload };

    case SUBMITTED_VALUES:
      return { ...state, apiPayload: action.payload };

    case CLEAR_DISPLAY_MESSAGE:
      return { ...state, messages: initialState.messages };
    case SEARCH_RESULTS:
      return { ...state, searchResults: action.payload };
    case REMOVE_VALIDATED_RESULT:
          if (action && action.payload && action.payload.index &&
            state.validatedAssayDetails &&
            state.validatedAssayDetails.data &&
            state.validatedAssayDetails.data &&
            !!(action.payload.index < state.validatedAssayDetails.data.length)
          ) {
            return update(state, {
              validatedAssayDetails: {
                data: {
                  [action.payload.index]: {
                    Errors: { $set: [] },
                  },
                },
              },
            });
          }
         else {
          return {
            ...state,
            validatedAssayDetails: {},
          }
        }
        
    case CHANGE_MODAL_TYPE:
      return {
        ...state,
        modalInfo: {
          ...state.modal,
          modalType: action.payload.modalType,
          uniqueAssayRowId: action.payload.uniqueRowId,
        },
      };

    case LOADING_PAGE:
      return { ...state, pageLoading: action.payload.pageLoading };
    case SELECT_UUID_FOR_ASSAY:
      return { ...state, uuid: action.payload, validatedAssayDetails: {} };
    case CLEAR_UUID_FOR_ASSAY:
      return { ...state, uuid: "" };

    case UPDATE_EDIT_REGION:
      return { ...state, editRegionDonorRange: action.payload };
    case REJECTED_COMMERCIAL_ID:
      return {
        ...state,
        rejectedCommercializedId: [
          ...state.rejectedCommercializedId,
          action.payload,
        ],
      };
    case CLEAR_COMMERCIAL_ID:
      return {
        ...state,
        rejectedCommercializedId: [],
      };

    default:
      return state;
  }
};

export default assays;
